import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
  eforms: [],
  templatesEform:[],
  eform: '',
  total: 0,
  folders: [],
  jwt: '',
  eformCreate: '',
  autocomplete: '',
  eformPais: '',
  urlLogo:''
}

const pickupModule = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}

export default pickupModule